<template>
  <v-container>
    <!-- Ingredient -->
    <v-simple-table v-if="ingredient" class="mt-12">
      <thead>
        <h1>Vista detallada de ingredient</h1>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>Nom</b>
          </td>
          <td>{{ ingredient.nom }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <!-- Botons d'opcions -->
    <div id="botonera">
      <!-- Dialog/Modal per editar ingredient -->
      <v-dialog v-model="dialogeditIngredient" persistent max-width="600">
        <template v-slot:activator="{ on }">
          <v-btn color="success" dark @click="btnDialogIngredient" v-on="on">Editar ingredient</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">Editar ingredient</v-card-title>
          <v-container>
            <v-form id="formIngredient" ref="formIngredient" class="mt-12">
              <v-row>
                <v-col md="12">
                  <v-text-field v-model="ingredient_edit.nom" label="Nom" required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialogeditIngredient = false">Cancel·lar</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="btneditIngredient"
              :disabled="!ingredient_edit.nom"
            >Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Dialog/Modal per editar ingredient -->
      <!-- Dialog/Modal per eliminar ingredient -->
      <v-dialog v-model="dialogEliminarIngredient" persistent max-width="600">
        <template v-slot:activator="{ on }">
          <v-btn color="error" dark v-on="on">Eliminar ingredient</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">Confirmar eliminar ingredient</v-card-title>
          <v-card-text>Està segur que vol eliminar este ingredient?</v-card-text>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialogEliminarIngredient = false">Cancel·lar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="btnEliminarIngredient">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Dialog/Modal per eliminar ingredient -->
    </div>
    <!-- Botons d'opcions -->
    <!-- ./Ingredient -->
    <!-- Footer -->
    <v-footer class="font-weight-medium" height="38%">
      <v-col class="text-center" cols="12" @click="redireccio('IngredientList')" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
    <!-- ./Footer -->
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

import { EventBus } from "@/event-bus.js";

export default {
  name: "ingredient-detail",
  data: () => ({
    ingredient: {
      nom: "",
    },
    ingredient_edit: {
      nom: "",
    },
    dialogeditIngredient: false,
    dialogEliminarIngredient: false
  }),
  methods: {
    ...mapActions(["editIngredient", "eliminarIngredient", "getIngredient"]),

    // Botonera
    btnDialogIngredient() {
      this.ingredient_edit = JSON.parse(JSON.stringify(this.ingredient));
    },
    btneditIngredient() {
      this.editIngredient(this.ingredient_edit).then(response => {
        if (response === 200) {
          EventBus.$emit("Ingredient.Notificacio", {
            text: "Ingredient editat correctament",
            color: "success"
          });
          this.dialogeditIngredient = false;
          this.getIngredient(this.ingredient.id).then(
            ingredient => (this.ingredient = ingredient)
          );
        } else
          EventBus.$emit("Ingredient.Notificacio", {
            text: "Error editant el ingredient",
            color: "error"
          });
      });
    },
    btnEliminarIngredient() {
      this.eliminarIngredient(this.ingredient.id).then(response => {
        if (response === 204) {
          EventBus.$emit("Ingredient.Notificacio", {
            text: "Ingredient eliminat correctament",
            color: "success"
          });
          this.$router.push({ name: "IngredientList" });
        } else
          EventBus.$emit("Ingredient.Notificacio", {
            text: "Error eliminant el ingredient",
            color: "error"
          });
      });
    },

    // Auxiliars
    redireccio(component) {
      this.$router.push({ name: component });
    }
  },
  created() {
    this.getIngredient(this.$route.params.id).then(
      ingredient => (this.ingredient = ingredient)
    );
  }
};
</script>

<style lang="scss" scoped>
// Taules
table {
  thead {
    h1 {
      text-align: center;
      padding-bottom: 1em;
    }
  }
  tbody {
    tr {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      td {
        width: 40%;
      }
    }
  }
}
#botonera {
  padding-bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    width: 45%;
  }
}
</style>